module.exports = __webpack_public_path__ + "img/hkLv1CoverGlobal.6bf8c2d1.png";